import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ImpactReportingOnboardingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ImpactReportingOnboardingQuery = { __typename?: 'Query', ImpactReportingOnboarding: { __typename?: 'ImpactReportingOnboarding', averageDaysToCompleteNewHireTraining30DayChange?: number | null, months: Array<{ __typename?: 'ImpactReportingOnboardingMonth', month: string, averageDaysToCompleteNewHireTraining: number }> } };

export type ImpactReportingEmployeeRetentionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ImpactReportingEmployeeRetentionQuery = { __typename?: 'Query', ImpactReportingEmployeeRetention: { __typename?: 'ImpactReportingEmployeeRetention', averageTenure?: number | null, averageTenureMonthChange?: number | null, cohorts: { __typename?: 'ImpactReportingEmployeeRetentionCohorts', day90Total?: number | null, day90Retained?: number | null, day60Total?: number | null, day60Retained?: number | null, day30Total?: number | null, day30Retained?: number | null }, months: Array<{ __typename?: 'ImpactReportingEmployeeRetentionCohortMonth', month: string, cohorts: { __typename?: 'ImpactReportingEmployeeRetentionCohorts', day90Total?: number | null, day90Retained?: number | null, day60Total?: number | null, day60Retained?: number | null, day30Total?: number | null, day30Retained?: number | null } }> } };

export type ImpactReportingComplianceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ImpactReportingComplianceQuery = { __typename?: 'Query', ImpactReportingCompliance: { __typename?: 'ImpactReportingCompliance', complianceTypes: Array<{ __typename?: 'ImpactReportingComplianceType', complianceType: Types.ComplianceType, totalUsers: number, compliantUsers: number }> } };

export type ImpactReportingConsistentOperationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ImpactReportingConsistentOperationsQuery = { __typename?: 'Query', ImpactReportingConsistentOperations: { __typename?: 'ImpactReportingConsistentOperations', totalCompletionScheduleWindows: number, onTimeCompletionScheduleWindows: number, totalSubmittedTaskLists: number, totalSubmittedTaskListLocations: number, totalSubmittedCheckins: number, totalSubmittedCheckinLocations: number, totalSubmittedTaskLists30DayChange?: number | null, totalSubmittedCheckins30DayChange?: number | null, onTimeCompletionScheduleWindows30DayChange?: number | null } };

export type ImpactReportingNewStoreOpeningsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ImpactReportingNewStoreOpeningsQuery = { __typename?: 'Query', ImpactReportingNewStoreOpenings: Array<{ __typename?: 'ImpactReportingStoreOpening', id?: string | null, locationId: number, locationName: string, firstMemberAddedAt?: string | null, openingDate?: string | null, evaluationStatus?: Types.StoreOpeningEvaluationStatus | null, evaluationNotes?: string | null, lastEditedByName?: string | null, lastEditedAt?: string | null }> };

export type UpdateStoreOpeningMutationVariables = Types.Exact<{
  input: Types.UpdateStoreOpeningInput;
}>;


export type UpdateStoreOpeningMutation = { __typename?: 'Mutation', updateStoreOpening: { __typename?: 'ImpactReportingStoreOpening', id?: string | null, locationId: number, locationName: string, firstMemberAddedAt?: string | null, openingDate?: string | null, evaluationStatus?: Types.StoreOpeningEvaluationStatus | null, evaluationNotes?: string | null, lastEditedByName?: string | null, lastEditedAt?: string | null } };


export const ImpactReportingOnboardingDocument = gql`
    query impactReportingOnboarding {
  ImpactReportingOnboarding {
    months {
      month
      averageDaysToCompleteNewHireTraining
    }
    averageDaysToCompleteNewHireTraining30DayChange
  }
}
    `;

/**
 * __useImpactReportingOnboardingQuery__
 *
 * To run a query within a React component, call `useImpactReportingOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactReportingOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactReportingOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpactReportingOnboardingQuery(baseOptions?: Apollo.QueryHookOptions<ImpactReportingOnboardingQuery, ImpactReportingOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactReportingOnboardingQuery, ImpactReportingOnboardingQueryVariables>(ImpactReportingOnboardingDocument, options);
      }
export function useImpactReportingOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactReportingOnboardingQuery, ImpactReportingOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactReportingOnboardingQuery, ImpactReportingOnboardingQueryVariables>(ImpactReportingOnboardingDocument, options);
        }
export type ImpactReportingOnboardingQueryHookResult = ReturnType<typeof useImpactReportingOnboardingQuery>;
export type ImpactReportingOnboardingLazyQueryHookResult = ReturnType<typeof useImpactReportingOnboardingLazyQuery>;
export type ImpactReportingOnboardingQueryResult = Apollo.QueryResult<ImpactReportingOnboardingQuery, ImpactReportingOnboardingQueryVariables>;
export const ImpactReportingEmployeeRetentionDocument = gql`
    query impactReportingEmployeeRetention {
  ImpactReportingEmployeeRetention {
    cohorts {
      day90Total
      day90Retained
      day60Total
      day60Retained
      day30Total
      day30Retained
    }
    months {
      month
      cohorts {
        day90Total
        day90Retained
        day60Total
        day60Retained
        day30Total
        day30Retained
      }
    }
    averageTenure
    averageTenureMonthChange
  }
}
    `;

/**
 * __useImpactReportingEmployeeRetentionQuery__
 *
 * To run a query within a React component, call `useImpactReportingEmployeeRetentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactReportingEmployeeRetentionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactReportingEmployeeRetentionQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpactReportingEmployeeRetentionQuery(baseOptions?: Apollo.QueryHookOptions<ImpactReportingEmployeeRetentionQuery, ImpactReportingEmployeeRetentionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactReportingEmployeeRetentionQuery, ImpactReportingEmployeeRetentionQueryVariables>(ImpactReportingEmployeeRetentionDocument, options);
      }
export function useImpactReportingEmployeeRetentionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactReportingEmployeeRetentionQuery, ImpactReportingEmployeeRetentionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactReportingEmployeeRetentionQuery, ImpactReportingEmployeeRetentionQueryVariables>(ImpactReportingEmployeeRetentionDocument, options);
        }
export type ImpactReportingEmployeeRetentionQueryHookResult = ReturnType<typeof useImpactReportingEmployeeRetentionQuery>;
export type ImpactReportingEmployeeRetentionLazyQueryHookResult = ReturnType<typeof useImpactReportingEmployeeRetentionLazyQuery>;
export type ImpactReportingEmployeeRetentionQueryResult = Apollo.QueryResult<ImpactReportingEmployeeRetentionQuery, ImpactReportingEmployeeRetentionQueryVariables>;
export const ImpactReportingComplianceDocument = gql`
    query impactReportingCompliance {
  ImpactReportingCompliance {
    complianceTypes {
      complianceType
      totalUsers
      compliantUsers
    }
  }
}
    `;

/**
 * __useImpactReportingComplianceQuery__
 *
 * To run a query within a React component, call `useImpactReportingComplianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactReportingComplianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactReportingComplianceQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpactReportingComplianceQuery(baseOptions?: Apollo.QueryHookOptions<ImpactReportingComplianceQuery, ImpactReportingComplianceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactReportingComplianceQuery, ImpactReportingComplianceQueryVariables>(ImpactReportingComplianceDocument, options);
      }
export function useImpactReportingComplianceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactReportingComplianceQuery, ImpactReportingComplianceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactReportingComplianceQuery, ImpactReportingComplianceQueryVariables>(ImpactReportingComplianceDocument, options);
        }
export type ImpactReportingComplianceQueryHookResult = ReturnType<typeof useImpactReportingComplianceQuery>;
export type ImpactReportingComplianceLazyQueryHookResult = ReturnType<typeof useImpactReportingComplianceLazyQuery>;
export type ImpactReportingComplianceQueryResult = Apollo.QueryResult<ImpactReportingComplianceQuery, ImpactReportingComplianceQueryVariables>;
export const ImpactReportingConsistentOperationsDocument = gql`
    query impactReportingConsistentOperations {
  ImpactReportingConsistentOperations {
    totalCompletionScheduleWindows
    onTimeCompletionScheduleWindows
    totalSubmittedTaskLists
    totalSubmittedTaskListLocations
    totalSubmittedCheckins
    totalSubmittedCheckinLocations
    totalSubmittedTaskLists30DayChange
    totalSubmittedCheckins30DayChange
    onTimeCompletionScheduleWindows30DayChange
  }
}
    `;

/**
 * __useImpactReportingConsistentOperationsQuery__
 *
 * To run a query within a React component, call `useImpactReportingConsistentOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactReportingConsistentOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactReportingConsistentOperationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpactReportingConsistentOperationsQuery(baseOptions?: Apollo.QueryHookOptions<ImpactReportingConsistentOperationsQuery, ImpactReportingConsistentOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactReportingConsistentOperationsQuery, ImpactReportingConsistentOperationsQueryVariables>(ImpactReportingConsistentOperationsDocument, options);
      }
export function useImpactReportingConsistentOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactReportingConsistentOperationsQuery, ImpactReportingConsistentOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactReportingConsistentOperationsQuery, ImpactReportingConsistentOperationsQueryVariables>(ImpactReportingConsistentOperationsDocument, options);
        }
export type ImpactReportingConsistentOperationsQueryHookResult = ReturnType<typeof useImpactReportingConsistentOperationsQuery>;
export type ImpactReportingConsistentOperationsLazyQueryHookResult = ReturnType<typeof useImpactReportingConsistentOperationsLazyQuery>;
export type ImpactReportingConsistentOperationsQueryResult = Apollo.QueryResult<ImpactReportingConsistentOperationsQuery, ImpactReportingConsistentOperationsQueryVariables>;
export const ImpactReportingNewStoreOpeningsDocument = gql`
    query impactReportingNewStoreOpenings {
  ImpactReportingNewStoreOpenings {
    id
    locationId
    locationName
    firstMemberAddedAt
    openingDate
    evaluationStatus
    evaluationNotes
    lastEditedByName
    lastEditedAt
  }
}
    `;

/**
 * __useImpactReportingNewStoreOpeningsQuery__
 *
 * To run a query within a React component, call `useImpactReportingNewStoreOpeningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactReportingNewStoreOpeningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactReportingNewStoreOpeningsQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpactReportingNewStoreOpeningsQuery(baseOptions?: Apollo.QueryHookOptions<ImpactReportingNewStoreOpeningsQuery, ImpactReportingNewStoreOpeningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactReportingNewStoreOpeningsQuery, ImpactReportingNewStoreOpeningsQueryVariables>(ImpactReportingNewStoreOpeningsDocument, options);
      }
export function useImpactReportingNewStoreOpeningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactReportingNewStoreOpeningsQuery, ImpactReportingNewStoreOpeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactReportingNewStoreOpeningsQuery, ImpactReportingNewStoreOpeningsQueryVariables>(ImpactReportingNewStoreOpeningsDocument, options);
        }
export type ImpactReportingNewStoreOpeningsQueryHookResult = ReturnType<typeof useImpactReportingNewStoreOpeningsQuery>;
export type ImpactReportingNewStoreOpeningsLazyQueryHookResult = ReturnType<typeof useImpactReportingNewStoreOpeningsLazyQuery>;
export type ImpactReportingNewStoreOpeningsQueryResult = Apollo.QueryResult<ImpactReportingNewStoreOpeningsQuery, ImpactReportingNewStoreOpeningsQueryVariables>;
export const UpdateStoreOpeningDocument = gql`
    mutation updateStoreOpening($input: UpdateStoreOpeningInput!) {
  updateStoreOpening(input: $input) {
    id
    locationId
    locationName
    firstMemberAddedAt
    openingDate
    evaluationStatus
    evaluationNotes
    lastEditedByName
    lastEditedAt
  }
}
    `;
export type UpdateStoreOpeningMutationFn = Apollo.MutationFunction<UpdateStoreOpeningMutation, UpdateStoreOpeningMutationVariables>;

/**
 * __useUpdateStoreOpeningMutation__
 *
 * To run a mutation, you first call `useUpdateStoreOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoreOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoreOpeningMutation, { data, loading, error }] = useUpdateStoreOpeningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStoreOpeningMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoreOpeningMutation, UpdateStoreOpeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStoreOpeningMutation, UpdateStoreOpeningMutationVariables>(UpdateStoreOpeningDocument, options);
      }
export type UpdateStoreOpeningMutationHookResult = ReturnType<typeof useUpdateStoreOpeningMutation>;
export type UpdateStoreOpeningMutationResult = Apollo.MutationResult<UpdateStoreOpeningMutation>;
export type UpdateStoreOpeningMutationOptions = Apollo.BaseMutationOptions<UpdateStoreOpeningMutation, UpdateStoreOpeningMutationVariables>;